import template from './sidebar.html';
import appCONST from './../../../constants/app.constants';
import appEvents from './../../../constants/appEvents.constant';
import {flightStates} from '../../flights/flights-routes';
import {hotelStates} from '../../hotels/hotels-routes';
import {carStates} from '../../cars/cars-routes';
import {railStates} from '../../ukrail/ukrail-routes';
import {trainStates} from '../../train/train-routes';
import {tripStates} from '../../trip/trip-routes';
import svgs from '../../../../images/icons/v2-icons/svg';

export default function Sidebar() {
    return {
        restrict: 'E',
        controller: SidebarController,
        controllerAs: 'sidebarCtrl',
        template,
        link,
    };

    function link($scope, $elem, $attrs, sidebarCtrl) {
        sidebarCtrl.$onInit();
    }
}

export function SidebarController(
    $scope,
    $state,
    $window,
    $sce,
    authService,
    userService,
    sidebarService,
    l10nService,
) {
    'ngInject';
        const vm = this;

        Object.assign(vm, {
            $onInit,
            areEurostarsVisible,
            navigateToRailSearch,
            getNavItemClassByState,
            isFlightSearchAvailable: sidebarService.isFlightSearchAvailable,
            isHotelSearchAvailable: sidebarService.isHotelSearchAvailable,
            isCarSearchAvailable: sidebarService.isCarSearchAvailable,
            isEurostarSearchAvailable: sidebarService.isEurostarSearchAvailable,
            isRailSearchAvailable: sidebarService.isRailSearchAvailable,
            isAuthorizedAgentUrl: authService.isAuthorizedAgentUrl(),
            l10nService,
        });

        function $onInit() {
            initUrls();
            initWatchers();
            initStates();
            $scope.rail = $sce.trustAsHtml(svgs.rail);
            $scope.hotel = $sce.trustAsHtml(svgs.hotel);
            $scope.car = $sce.trustAsHtml(svgs.car);
            $scope.folder = $sce.trustAsHtml(svgs.folder);
            $scope.euro = $sce.trustAsHtml(svgs.euro);
            $scope.plane = $sce.trustAsHtml(svgs.plane);
        }

        function navigateToRailSearch() {
            if (sidebarService.isRailSearchAvailable()) {
                $state.go(railStates.ROUNDTRIP);
            } else {
                $window.open(vm.trainlineLink);
            }
        }

        function getNavItemClassByState(stateName) {
            return {active: !!$state.includes(stateName)};
        }

        function initWatchers() {
            // TODO move `accessToken` to component parameters AP-1657
            $scope.$on(appEvents.REFRESH_TOKEN, initUrls);
        }

        function initUrls() {
            const accessToken = authService.getAccessToken();
            vm.adminLink = `${appCONST.adminUrl}?access_token=${encodeURIComponent(accessToken)}`;
            vm.trainlineLink = `${appCONST.trainlineUrl}?token=${encodeURIComponent(accessToken)}`;
        }

        function areEurostarsVisible() {
            if ($scope.readOnlyMode) {
                return true;
            }

            return authService.getAvailableServicesFromSessionStorage().IsEurostarSearchAvailable
                && (userService.isUKRegion() || userService.isUSRegion());
        }

        function initStates() {
            vm.mainFlightState = flightStates.MAIN;
            vm.flightRoundTripState = flightStates.ROUNDTRIP;
            vm.mainHotelState = hotelStates.MAIN;
            vm.mainCarState = carStates.MAIN;
            vm.mainRailState = railStates.MAIN;
            vm.mainTrainState = trainStates.MAIN;
            vm.trainRoundTripState = trainStates.ROUNDTRIP;
            vm.mainTripState = tripStates.MAIN;
        }
    }



// WEBPACK FOOTER //
// ./src/app/modules/main/sidebar/sidebar-component.js